import { api } from '@api/client'
import { cached, makeKey, FIVE_MINUTES_MS } from '@cache/requestCache'

// Existing Home endpoint, moved to the entity layer for this flow.
export function getAssetInspections (companyId, siteId, assetId) {
  const url = `/company/${companyId}/sites/${siteId}/assets/${assetId}/inspections`
  return cached(
    makeKey(url, {}),
    async () => (await api.get(url)).data,
    FIVE_MINUTES_MS
  )
}
